import React, { useState } from "react";
import {
  FormControl,
  FormControlLabel,
  Checkbox,
  FormGroup,
  Radio,
  RadioGroup,
} from "@mui/material";

const ChatOptions = ({ chat, index, localChats, handleOptionSelect }) => {
  const [selectedItems, setSelectedItems] = useState([]);

  const handleCheckboxChange = (event, item) => {
    let updatedSelection;
    if (event.target.checked) {
      updatedSelection = [...selectedItems, item];
    } else {
      updatedSelection = selectedItems.filter((selected) => selected !== item);
    }

    setSelectedItems(updatedSelection);

    // Only call the callback when selection equals the limit
    if (updatedSelection.length === chat.selectionLimit) {
      handleOptionSelect(updatedSelection.join(","));
    } else {
      // Clear selection if limit is not met (or if deselected below limit)
      //handleOptionSelect("");
    }
  };

  const handleRadioChange = (event) => {
    // For radio buttons, immediately call the callback with the selected value
    handleOptionSelect(event.target.value);
  };

  return (
    <div>
      {(chat.options || []).length > 0 && (
        <FormControl
          disabled={localChats.length - 1 !== index}
          sx={{
            mt: 2,
            backgroundColor: "#1b3c34",
            px: 2,
            borderRadius: "8px",
            color: "#ffffff",
            "& .MuiFormLabel-root": {
              color: "#ffffff",
              "&.Mui-focused": {
                color: "#ffffff",
              },
            },
            "& .MuiCheckbox-root": {
              color: "#a8dadc",
              "&.Mui-checked": {
                color: "#a8dadc",
              },
            },
            "& .MuiRadio-root": {
              color: "#a8dadc",
              "&.Mui-checked": {
                color: "#a8dadc",
              },
            },
            "& .MuiFormControlLabel-label": {
              color: "#ffffff",
            },
          }}
        >
          {chat.selection === "multi" ? (
            <FormGroup row>
              {chat.options.map((item) => (
                <FormControlLabel
                  key={item}
                  value={item}
                  control={
                    <Checkbox
                      checked={selectedItems.includes(item)}
                      onChange={(e) => handleCheckboxChange(e, item)}
                      disabled={
                        !selectedItems.includes(item) &&
                        selectedItems.length >= chat.selectionLimit
                      }
                    />
                  }
                  label={item}
                />
              ))}
            </FormGroup>
          ) : (
            <RadioGroup row onChange={handleRadioChange}>
              {chat.options.map((item) => (
                <FormControlLabel
                  key={item}
                  value={item}
                  control={<Radio />}
                  label={item}
                />
              ))}
            </RadioGroup>
          )}
        </FormControl>
      )}
    </div>
  );
};

export default ChatOptions;
